import React, { useState, useEffect } from "react"
import {
  Container,
  Button,
  Modal,
  ModalBody,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import { Link as Gatsbylink } from "gatsby"

import { auth, signInWithGoogle } from "../../utils/firebase"
import { useAuthState } from "react-firebase-hooks/auth"
import useAuthUser from "../../hooks/useAuthUser"

import { FaGoogle } from "react-icons/fa"

function User() {
  const [loginPopupVisible, setLoginPopupVisible] = useState(false)
  const [userProfilOpen, setUserProfilOpen] = useState(false)
  const [user, loading, error] = useAuthState(auth)

  if (user)
    return (
      <Dropdown
        isOpen={userProfilOpen}
        toggle={() => setUserProfilOpen(c => !c)}
      >
        <DropdownToggle tag="div">
          <div className=" text-capitalize mb-3">
            <img
              src={user.photoURL}
              width="33"
              className="thumbnail rounded-circle mr-2"
            />
            {user.displayName}
          </div>
        </DropdownToggle>
        <DropdownMenu>
          {/* <DropdownItem disabled>Profil</DropdownItem> */}
          <DropdownItem>
            <Gatsbylink to={"/favorites"} className="text-dark">
              Saved Graphs
            </Gatsbylink>
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem onClick={() => auth.signOut()}>Logout</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    )
  return (
    <>
      <div
        className="text-center mb-3"
        onClick={() => setLoginPopupVisible(true)}
      >
        Login
      </div>
      <LoginPopup
        loginPopupVisible={loginPopupVisible}
        hide={() => setLoginPopupVisible(false)}
      />
    </>
  )
}

const LoginPopup = ({ loginPopupVisible, hide }) => {
  const user = useAuthUser()

  useEffect(() => {
    if (user) {
      hide()
    }
  }, [user])
  if (user) return null
  return (
    <Modal isOpen={loginPopupVisible && !user} toggle={hide}>
      <ModalBody>
        <h2>Login</h2>
        <div className="d-flex justify-content-center">
          <div
            className="px-4 py-1 border rounded border-danger shadow"
            onClick={signInWithGoogle}
            style={{
              cursor: "pointer",
            }}
          >
            <FaGoogle /> Login with Google
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}
export default User
